module.exports = __webpack_public_path__ + "img/MenuButton_DB.2bfa3373.jpg";